import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthorizationsComponent } from './authorizations.component';
import { AuthorizationsRoutingModule } from './authorizations-routing.module';

import { AuthorizeComponent } from './authorize/authorize.component';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [AuthorizationsComponent, AuthorizeComponent],
  imports: [
    CoreModule,
    SharedModule,
    AuthorizationsRoutingModule
  ],
  exports: [FormsModule, ReactiveFormsModule]
})
export class AuthorizationsModule { }
